import React from 'react';
import { Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Big Loading Icon on App Load
export const Loading = () => (
  <div className="d-flex flex-row justify-content-center mt-5">
    <div style={{ marginTop: '15px' }}>
      <FontAwesomeIcon icon="spinner" pulse />
    </div>
    <h1>Loading</h1>
  </div>
);

// Smaller loading icons used throughout app
export const CustomLoading = () => (
  <div className="d-flex flex-row justify-content-center mt-5">
    <Spinner color="dark" />
    Loading
  </div>
);

export const LoadingIcon = () => (
  <Spinner color="dark" />
);
